// extracted by mini-css-extract-plugin
export default {"fileDocumentStyle":"styles_fileDocumentStyle__o9X1z"};